import { getSearchParams, PackagePickerSteps, UrlUtils, wixServerData } from '@wix/package-picker-shared';
import { createModuleExtension } from '@wix/premium-fed-sdk/@premium-module';
import React from 'react';
import { createBrowserRouter, RouterProvider, useLocation, useNavigate, useRouteError } from 'react-router-dom';
import { useAnonymous } from '../hooks';
const STUDIO_PREFIX = '/studio';

/** Builds path for a step: anonymous = /{step}, studio = /studio/{step}. */
export const routesBuilder = function (step, isAnonymous) {
  if (isAnonymous === void 0) {
    isAnonymous = false;
  }
  const pathPrefix = isAnonymous ? '' : STUDIO_PREFIX;
  return `${pathPrefix}/${step}`;
};

/**
 * Normalizes basename for React Router: one leading slash, no trailing slash.
 * Use with wixServerData.get().basename so routing matches correctly in both anonymous and studio.
 */
export const normalizeBasename = basename => {
  const trimmed = (basename ?? '').trim();
  const withLeading = trimmed.startsWith('/') ? trimmed : `/${trimmed}`;
  const noTrailing = withLeading.length > 1 && withLeading.endsWith('/') ? withLeading.slice(0, -1) : withLeading;
  return noTrailing || '/';
};
function RouterErrorHandler() {
  const unknownError = useRouteError();
  throw unknownError;
}
export const RouterExtension = createModuleExtension(routes => {
  return {
    extensionName: 'RouterExtension',
    internals: {
      hooks: {
        useChangeRoute: () => {
          const navigate = useNavigate();
          const {
            isAnonymous
          } = useAnonymous();
          return step => {
            const {
              allSearchParams
            } = getSearchParams();
            const path = routesBuilder(step, isAnonymous);
            const params = Object.fromEntries(allSearchParams.entries());
            const fullUrl = UrlUtils.buildUrl({
              url: path,
              params
            });
            const {
              pathname,
              search
            } = new URL(fullUrl);
            navigate(pathname + search);
          };
        },
        useCurrentStep: () => {
          const location = useLocation();
          const pathname = location.pathname;
          if (pathname === '/' || pathname === '') {
            return PackagePickerSteps.SELECT_PLAN;
          }
          const stepMatch = pathname.replace(`${STUDIO_PREFIX}/`, '');
          return stepMatch;
        }
      },
      components: {
        AppRouter: () => {
          const basename = normalizeBasename(wixServerData.get().basename);
          const {
            isAnonymous
          } = useAnonymous();
          const stepRoutes = Array.from(routes.entries()).map(_ref => {
            let [step, ComponentRoute] = _ref;
            return {
              path: routesBuilder(step, isAnonymous),
              element: /*#__PURE__*/React.createElement(ComponentRoute, null),
              errorElement: /*#__PURE__*/React.createElement(RouterErrorHandler, null)
            };
          });
          const router = createBrowserRouter(stepRoutes, {
            basename
          });
          return /*#__PURE__*/React.createElement(RouterProvider, {
            router: router
          });
        }
      }
    }
  };
});
//# sourceMappingURL=router.extension.js.map